import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {HtmlLinkIcon} from 'shells/icon/svg/html-link-icon';
import {SuccessMessageIcon} from 'shells/icon/svg/success-message-icon';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

type Props = {
    type: string;
    content: string | null | undefined;
    onClick: () => void;
};

export function AfterSubmissionCard(props: Props) {
    return (
        <TwoLineButtonCard onClick={props.onClick}>
            <TwoLine
                icon={props.type === 'redirectUrl' ? HtmlLinkIcon : SuccessMessageIcon}
                iconSize={24}
                iconColor={colors.grey}
                topRow={
                    props.type === 'redirectUrl' ? 'Redirect to a URL' : 'Show a success message'
                }
                bottomRow={props.content}
                isLargeWithSmallBottomRow={true}
                shouldCenterSingleLine={true}
            />
        </TwoLineButtonCard>
    );
}
